import { Fancybox } from "@fancyapps/ui";

const form_service = document.querySelector('#form_service')

Fancybox.bind("[data-fancybox]", {
  on: {
    "Carousel.ready Carousel.change": (fancybox) => {
      const slide = fancybox.getSlide();
      const triggerEl = slide.triggerEl;
      const service_name = triggerEl.getAttribute('data-service')

      form_service.value = service_name

      if(service_name) {
        form_service.parentElement.classList.add('is-filled')
        form_service.parentElement.classList.remove('is-empty')
      } else {
        form_service.parentElement.classList.add('is-empty')
        form_service.parentElement.classList.remove('is-filled')
      }
    },
  },
});
